import { Routes } from '@angular/router';

import { v2On } from '../v2/ui-v2.guard';

export const planBillingRoutes: Routes = [
  {
    path: 'plan-billing',
    canMatch: [v2On],
    loadComponent: () => import('../v2/pages/plan/plan-billing-v2.page').then((m) => m.PlanBillingV2Page),
  },
  {
    path: 'plan-billing',
    loadComponent: () => import('./plan-billing.page').then((m) => m.PlanBillingPage),
  },
];
